<template>
    <div class="gst-footer">
        <p>
            {{ $t('copyright', { year: year }) }}<br /><span>{{ appInfo }}</span>
        </p>
    </div>
</template>
<script>
import { appConstants, dateConstants } from '@utils/constants';
import dateFilter from '@/utils/date';

export default {
    name: 'Footer',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'layouts.default.footer',
    },
    computed: {
        year() {
            return new Date().getFullYear();
        },
        appInfo() {
            return `v${this.appVersion} - Build: ${this.appBuildDateTime}`;
        },
        appVersion() {
            return appConstants.VERSION;
        },
        appBuildDateTime() {
            const buildTimestamp = appConstants.BUILD_TIMESTAMP;

            if (!buildTimestamp) return '';

            return dateFilter(new Date(buildTimestamp), dateConstants.FORMAT.TIMESTAMP);
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';

.gst-footer {
    border-top: 1px solid theme-color('quinary');

    span {
        font-size: font-size('2xs');
        opacity: 0.5;
    }
}
</style>
